/**
 * Centralized z-index management for the application
 * Values are organized in layers from lowest to highest priority
 */

export const Z_INDEX = {
    // Base layer - behind everything
    BEHIND: -1,

    // Default layer - normal content
    DEFAULT: 0,

    // Content layers - slightly elevated content
    CONTENT_LOW: 1,
    CONTENT_MID: 2,
    CONTENT_HIGH: 3,

    // Navigation layers - navigation elements
    NAV_LOW: 10,
    NAV_MID: 20,
    NAV_HIGH: 30,

    // Header and fixed elements
    HEADER: 40,
    STICKY_ELEMENTS: 50,

    // Dropdown and floating elements
    DROPDOWN: 60,
    TOOLTIP: 70,
    POPOVER: 80,

    // Overlay layers - semi-transparent overlays
    OVERLAY_LOW: 85,
    OVERLAY_MID: 90,
    OVERLAY_HIGH: 95,

    // Modal layers - modal dialogs and popups
    MODAL_BACKDROP: 96,
    MODAL_CONTENT: 97,
    MODAL_HIGH: 98,

    // Notification layers - toasts, alerts, notifications
    NOTIFICATION: 91,
    TOAST: 92,
    ALERT: 93,

    // Loading and splash screens
    LOADING: 94,
    SPLASH: 95,

    // Maximum priority - emergency overlays
    EMERGENCY: 99,
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;
export type ZIndexValue = (typeof Z_INDEX)[ZIndexKey];
